import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=096f1799&"
import script from "./AnnouncementList.vue?vue&type=script&lang=js&"
export * from "./AnnouncementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports